const PREFIX = 'SIMPLE_MEDICAL_RECORD_'
export const SIMPLE_MEDICAL_RECORD = {
  LIST_REQUEST: `${PREFIX}LIST_REQUEST`,
  LIST_SUCCESS: `${PREFIX}LIST_SUCCESS`,
  LIST_FAILURE: `${PREFIX}LIST_FAILURE`,
  GET_ONE_REQUEST: `${PREFIX}GET_ONE_REQUEST`,
  GET_ONE_SUCCESS: `${PREFIX}GET_ONE_SUCCESS`,
  GET_ONE_FAILURE: `${PREFIX}GET_ONE_FAILURE`,
  CREATE_API_REQUEST: `${PREFIX}CREATE_API_REQUEST`,
  CREATE_API_SUCCESS: `${PREFIX}CREATE_API_SUCCESS`,
  CREATE_API_FAILURE: `${PREFIX}CREATE_API_FAILURE`,
  UPDATE_REQUEST: `${PREFIX}UPDATE_REQUEST`,
  UPDATE_SUCCESS: `${PREFIX}UPDATE_SUCCESS`,
  UPDATE_FAILURE: `${PREFIX}UPDATE_FAILURE`,
  CLEAR_NOTIFY: `${PREFIX}CLEAR_NOTIFY`
}
